export default __webpack_public_path__ + "static/media/builtMTG.3c289b3d.png";